import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row"
};
const _hoisted_2 = { class: "col" };
const _hoisted_3 = { class: "col-6 col-md-8 mt-3 mb-3" };
const _hoisted_4 = { class: "col-3 col-md-2 mt-3 mb-3" };
const _hoisted_5 = { class: "col-3 col-md-2 mt-3 mb-3" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-md-3 col-12" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-3 d-md-block d-none" }, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-3 col-6 mt-2 mt-md-0" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-3 col-6 mt-2 mt-md-0" }, null, -1);
const _hoisted_11 = { class: "row mt-0 mt-md-2" };
const _hoisted_12 = { class: "col-md-3 col-12" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-3 d-md-block d-none" }, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-3 d-md-block d-none" }, null, -1);
const _hoisted_15 = { class: "col-md-3 col-12 mt-2 mt-md-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.page?.instruction)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_g_dynamic_html, {
                        template: _ctx.page.instruction
                    }, null, 8, ["template"])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.pages, (tPage) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row border border-2 bg-light ms-0 me-0 mb-2 mt-2 align-items-center",
                    key: tPage.id
                }, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$forms.getPageTitle(tPage)), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_g_button, {
                            text: "Bearbeiten",
                            onClick: ($event) => (_ctx.onCommand('page-goto', { page: tPage })),
                            disabled: !tPage.isEnabled
                        }, null, 8, ["onClick", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_g_button, {
                            "button-style": "btn-danger",
                            text: "Entfernen",
                            onClick: ($event) => (_ctx.onCommand('page-remove', { master: _ctx.page, page: tPage })),
                            disabled: _ctx.page.pages.length <= 1 || !tPage.isEnabled
                        }, null, 8, ["onClick", "disabled"])
                    ])
                ]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                (_ctx.canAddMore)
                    ? (_openBlock(), _createBlock(_component_g_button, {
                        key: 0,
                        text: "+ Hinzufügen",
                        "button-style": "btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCommand('page-add', { page: _ctx.page }))),
                        isLoading: _ctx._isWorking
                    }, null, 8, ["isLoading"]))
                    : _createCommentVNode("", true)
            ]),
            _hoisted_8,
            _hoisted_9,
            _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                (!_ctx.page.isFirstPage)
                    ? (_openBlock(), _createBlock(_component_g_button, {
                        key: 0,
                        text: "<< Zurück",
                        "button-style": "btn-outline-secondary",
                        disabled: !_ctx.page.previousPage,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onCommand('back', { page: _ctx.page }))),
                        isLoading: _ctx._isWorking
                    }, null, 8, ["disabled", "isLoading"]))
                    : _createCommentVNode("", true)
            ]),
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_g_button, {
                    text: _ctx.page.nextText,
                    disabled: !_ctx.page.nextCommand2,
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.onCommand(_ctx.page?.nextCommand2, { page: _ctx.page }))),
                    isLoading: _ctx._isWorking
                }, null, 8, ["text", "disabled", "isLoading"])
            ])
        ])
    ], 64));
}
